<template>
  <section class="app-sidebar">
    <nav id="sidebar" class="sidebar sidebar-offcanvas">
      <ul class="nav">
        <the-sidebar-profile />
        <li
          v-for="item in sidebarItems"
          :key="item.$ID"
          class="nav-item menu-items"
          :class="{ dropdown: item.Items }"
        >
          <sidebar-simple-item
            v-if="!item.Items"
            :id="item.$ID"
            :title="$t(item.Caption)"
            :icon="item.Icon"
            :icon-class="item.IconClass"
            :router-to="{ name: item.Action.Page }"
            @click="collapseAll"
          ></sidebar-simple-item>

          <sidebar-groups-item
            v-if="item.Items"
            :id="item.$ID"
            :title="$t(item.Caption)"
            :icon="item.Icon"
            :icon-class="item.IconClass"
            :children="item.Items"
          ></sidebar-groups-item>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'SmartOeeSidebar',
  components: {
    SidebarGroupsItem: () => import('@/components/sidebar/SidebarGroupsItem'),
    SidebarSimpleItem: () => import('@/components/sidebar/SidebarSimpleItem'),
    TheSidebarProfile: () => import('@/components/sidebar/TheSidebarProfile'),
  },
  data() {
    return {
      collapses: [
        {
          show: false,
        },
        {
          show: false,
        },
        {
          show: false,
        },
      ],
    };
  },
  computed: {
    sidebarItems() {
      return this.$store.getters.AppNavigation;
    },
    userName() {
      return this.$store.getters.userName;
    },
    userPhoto() {
      return this.$store.getters.userPhoto;
    },
    userRole() {
      return this.$authCore.userRole;
    },
  },
  mounted() {
    const body = document.querySelector('body');
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll('.sidebar .nav-item').forEach(function (el) {
      el.addEventListener('mouseover', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.add('hover-open');
        }
      });
      el.addEventListener('mouseout', function () {
        if (body.classList.contains('sidebar-icon-only')) {
          el.classList.remove('hover-open');
        }
      });
    });

    document.querySelector('#main-container').addEventListener('click', function () {
      let sidebar = document.querySelector('#sidebar');
      if (sidebar.classList.contains('active')) {
        sidebar.classList.remove('active');
      }
    });
  },
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    collapseAll() {
      var exp_element = document.getElementsByClassName('show');
      if (exp_element.length > 0) {
        var elm_id = exp_element[0].id;
        this.$root.$emit('bv::toggle::collapse', elm_id);
      }
    },
  },
};
</script>

<style>
.active {
  color: white !important;
}
.fixed-left {
  position: fixed;
  z-index: 15;
}
</style>
